const common = {
  // Nav
  "nav.guides": "홈",
  "nav.clientSdk": "기능",
  "nav.serverApi": "문서",
  "nav.download": "다운로드",
  "nav.android": "Android",
  "nav.ios": "iOS",
  "nav.pc": "웹 버전",
  "nav.github": "GitHub",
  "nav.blog": "블로그",

  // Hero
  "hero.badge": "오픈 소스 메시징",
  "hero.title1": "Build with",
  "hero.title2": "TupIM",
  "hero.desc": "TupIM은 IM 전문가들이 개발한 오픈 소스 인스턴트 메시징 컴포넌트입니다. IM 서버와 클라이언트 SDK를 포함하며, 경량화되고 유연하며 확장이 용이합니다. 프라이빗 배포로 데이터 보안을 유지하세요.",
  "hero.download": "다운로드",
  "hero.stat.devs": "개발자",
  "hero.stat.msgs": "메시지/일",
  "hero.badge2.title": "종단간 암호화",
  "hero.badge2.desc": "메시지가 안전하게 보호됩니다",

  // Features
  "features.label": "핵심 기능",
  "features.title": "커뮤니케이션에 필요한 모든 것",
  "features.subtitle": "TupIM은 메시지, 통화, 그룹, 파일 등 완전한 인스턴트 메시징 솔루션을 제공합니다.",

  "feat.msg.title": "인스턴트 메시지",
  "feat.msg.desc": "텍스트, 이모지, 이미지, 음성, 비디오 메시지를 밀리초 단위로 전달.",
  "feat.call.title": "음성 및 영상 통화",
  "feat.call.desc": "일대일 또는 그룹 고화질 통화, 화면 공유 지원.",
  "feat.group.title": "그룹 채팅",
  "feat.group.desc": "수천 명의 멤버를 지원하는 그룹 생성 및 관리.",
  "feat.file.title": "파일 전송",
  "feat.file.desc": "파일, 사진, 비디오를 빠르고 안전하게 전송. 재개 기능 지원.",
  "feat.encrypt.title": "종단간 암호화",
  "feat.encrypt.desc": "모든 메시지가 E2E 암호화. 개인 키는 기기에만 저장.",
  "feat.notify.title": "푸시 알림",
  "feat.notify.desc": "모든 플랫폼에서 즉시 푸시, 중요한 메시지를 놓치지 마세요.",
  "feat.cross.title": "PC+APP 지원",
  "feat.cross.desc": "하나의 SDK로 Web, Android, iOS를 커버.",
  "feat.private.title": "프라이빗 배포",
  "feat.private.desc": "자체 서버에 배포. 데이터를 완전히 자체 관리. 기업급 보안.",
  "feat.selfhost.title": "고성능",
  "feat.selfhost.desc": "Go로 구축. 단일 노드에서 수백만 동시 연결 지원.",

  "features.sdk.title": "멀티플랫폼 SDK 지원",
  "features.sdk.desc": "어떤 기술 스택이든 TupIM SDK가 준비되어 있습니다",

  // Api hero section
  "api.hero.title1": "Build with",
  "api.hero.title2": "TupIM",
  "api.hero.desc": "TupIM은 IM 전문가들이 개발한 오픈 소스 인스턴트 메시징 컴포넌트입니다. 프라이빗 배포를 지원하여 데이터 보안을 보장합니다.",
  "api.hero.btn.start": "시작하기",
  "api.hero.btn.guide": "시작 가이드",

  // Api / Deploy section
  "api.open.title": "완전 오픈 소스",
  "api.open.desc": "TupIM 서버와 모든 SDK는 MIT 라이선스로 GitHub에 공개되어 있습니다.",
  "api.open.contrib": "기여자",
  "api.open.btn": "GitHub에서 보기",
  "api.deploy.title": "간편한 셀프 호스트",
  "api.deploy.desc": "몇 분 안에 자체 서버에 TupIM을 배포하세요. 서드파티 의존성 없음.",
  "api.deploy.f1": "Docker Compose 원클릭 배포",
  "api.deploy.f2": "Kubernetes 클러스터 배포 지원",
  "api.deploy.f3": "완전한 모니터링 및 로그 시스템",
  "api.deploy.btn": "배포 문서 읽기",

  // Help
  "help.title": "무엇을 도와드릴까요?",
  "help.demo.title": "데모 확인",
  "help.demo.desc": "앱을 다운로드하여 테스트하거나 데모 웹사이트를 방문할 수 있습니다.",
  "help.demo.link": "지금 이동 →",
  "help.support.title": "지원",
  "help.support.desc": "TupIM 코드 저장소에서 관련 이슈를 찾거나 제출할 수 있습니다.",
  "help.support.link": "지금 이동 →",
  "help.faq.title": "자주 묻는 질문",
  "help.faq.desc": "FAQ 섹션에서 일반적인 질문에 대한 답변을 찾아보세요.",
  "help.faq.link": "FAQ 보기 →",

  // Community
  "community.title": "커뮤니티 참여",
  "community.desc": "성장하는 커뮤니티와 교류하여 최신 업데이트와 지원을 받으세요.",
  "community.slack": "Slack →",

  // Download page
  "download.android.badge": "Android 앱",
  "download.android.title": "TupIM Android 버전 다운로드",
  "download.android.desc": "텍스트, 음성, 영상 통화, 그룹 채팅, 파일 전송 등 풍부한 기능의 Android 앱.",
  "download.android.version": "최신 버전",
  "download.android.size": "패키지 크기",
  "download.android.require": "시스템 요구 사항",
  "download.android.require.val": "Android 5.0 이상",
  "download.android.btn": "APK 다운로드",
  "download.android.qr": "QR 코드로 다운로드",
  "download.android.qr.desc": "스마트폰 카메라 또는 QR 스캐너로 스캔",
  "download.android.tip": "다운로드 후 알 수 없는 출처의 앱 설치를 허용하세요",
  "download.android.cta.title": "지금 시작하기",
  "download.android.cta.desc": "무료 다운로드 — 안전하고 고성능 인스턴트 메시징 체험",

  "download.ios.badge": "iOS 앱",
  "download.ios.title": "TupIM iOS 버전 다운로드",
  "download.ios.desc": "iPhone과 iPad를 위한 인스턴트 메시징 앱. 모든 핵심 기능 지원.",
  "download.ios.version": "최신 버전",
  "download.ios.size": "패키지 크기",
  "download.ios.require": "시스템 요구 사항",
  "download.ios.require.val": "iOS 13.0 이상",
  "download.ios.btn": "App Store에서 다운로드",
  "download.ios.btn2": "TestFlight 베타",
  "download.ios.qr": "QR 코드로 다운로드",
  "download.ios.qr.desc": "iPhone 카메라로 스캔하여 App Store로 이동",
  "download.ios.tip": "iOS 15.0 이상의 iPhone 및 iPad 지원",
  "download.ios.cta.title": "지금 시작하기",
  "download.ios.cta.desc": "App Store에서 무료 다운로드, 또는 TestFlight에서 최신 기능을 먼저 체험",

  // PC / Web version
  "download.pc.badge": "브라우저 버전",
  "download.pc.title": "TupIM 웹 브라우저 버전",
  "download.pc.desc": "설치 불필요. 웹 브라우저에서 언제 어디서나 접속하여 완전한 인스턴트 메시징 기능을 즐기세요.",
  "download.pc.btn.open": "지금 열기",
  "download.pc.tip": "무료 · 설치 불필요. 모든 기기와 동기화.",
  "download.pc.features.title": "핵심 기능",
  "download.pc.features.subtitle": "브라우저에서 사용할 수 있는 완전한 커뮤니케이션 경험",
  "download.pc.screenshots.title": "스크린샷",
  "download.pc.ss.chats": "채팅",
  "download.pc.ss.call": "영상 통화",
  "download.pc.ss.group": "그룹 채팅",
  "download.pc.ss.file": "파일 관리",
  "download.pc.cta.title": "웹 브라우저로 시작하기",
  "download.pc.cta.desc": "설치 없이 어떤 브라우저에서도 바로 사용 가능합니다",
  "download.pc.cta.btn": "브라우저에서 열기",
  "download.pc.browser.support": "지원 브라우저",

  // Download features
  "download.feature.msg": "인스턴트 메시지",
  "download.feature.msg.desc": "텍스트, 이모지, 이미지, 음성, 비디오 등 메시지 유형 지원",
  "download.feature.call": "음성/영상 통화",
  "download.feature.call.desc": "일대일 또는 그룹 음성/영상 통화, 선명하고 부드러움",
  "download.feature.group": "그룹 채팅",
  "download.feature.group.desc": "그룹 생성 및 관리, 수천 명의 멤버 지원",
  "download.feature.file": "파일 전송",
  "download.feature.file.desc": "파일, 사진, 비디오 빠르고 안전한 전송",
  "download.feature.encrypt": "종단간 암호화",
  "download.feature.encrypt.desc": "모든 메시지가 E2E 암호화되어 프라이버시 보호",
  "download.feature.notify": "푸시 알림",
  "download.feature.notify.desc": "중요 메시지 즉시 푸시, 놓치지 않기",
  "download.feature.shortcut": "키보드 단축키",
  "download.feature.shortcut.desc": "풍부한 단축키로 데스크탑 생산성 향상",

  // Download Section (homepage)
  "dl.label": "다운로드",
  "dl.title": "멀티플랫폼 다운로드",
  "dl.subtitle": "Android, iOS 및 모든 주요 브라우저에서 사용 가능. 모든 기기에서 메시지가 원활하게 동기화됩니다.",
  "dl.sync": "모두 무료. 모든 기기에서 실시간 동기화.",
  "dl.android.title": "Android",
  "dl.android.desc": "Android 스마트폰 및 태블릿을 위한 완전한 기능의 메시징 앱.",
  "dl.android.req": "Android 5.0+",
  "dl.android.btn": "Android용 다운로드",
  "dl.ios.title": "iPhone & iPad",
  "dl.ios.desc": "iPhone과 iPad를 위한 네이티브 iOS 경험. 부드럽고 빠른 Apple 기기 최적화.",
  "dl.ios.req": "iOS 15.0+",
  "dl.ios.btn": "iOS용 다운로드",
  "dl.pc.title": "브라우저 버전",
  "dl.pc.desc": "설치 불필요. 웹 브라우저에서 바로 접속.",
  "dl.pc.req": "모든 브라우저",
  "dl.pc.btn": "브라우저에서 열기",

  // Showcase
  "showcase.label": "상세 분석",
  "showcase.title": "모든 기능, 당신을 위해 설계",
  "showcase.subtitle": "인스턴트 메시지부터 영상 통화까지, 모든 모듈이 최고의 커뮤니케이션 경험을 제공합니다.",
  "showcase.msg.title": "인스턴트 메시지",
  "showcase.msg.tag": "메시지",
  "showcase.msg.desc": "밀리초 단위 전달과 리치 미디어 메시지 지원",
  "showcase.msg.p1": "텍스트, 이모지, 이미지, 음성, 비디오 등 20종 이상 메시지 유형",
  "showcase.msg.p2": "읽음 확인 — 누가 읽었는지 확인 가능",
  "showcase.msg.p3": "메시지 취소, 인용 답장, @멘션 지원",
  "showcase.msg.p4": "오프라인 메시지 자동 동기화",
  "showcase.call.title": "음성 및 영상 통화",
  "showcase.call.tag": "통화",
  "showcase.call.desc": "약한 네트워크에서도 안정적인 HD 통화",
  "showcase.call.p1": "일대일 및 다자간 그룹 음성/영상 통화 지원",
  "showcase.call.p2": "화면 공유 기능 내장",
  "showcase.call.p3": "어댑티브 비트레이트로 안정적인 통화",
  "showcase.call.p4": "통화 녹음 기능",
  "showcase.group.title": "그룹 채팅",
  "showcase.group.tag": "그룹",
  "showcase.group.desc": "수천 명을 지원하는 유연한 그룹 관리",
  "showcase.group.p1": "그룹당 최대 1,000명",
  "showcase.group.p2": "다단계 관리자 역할 및 세밀한 권한 제어",
  "showcase.group.p3": "그룹 공지, 공유 파일, 그룹 앨범 내장",
  "showcase.group.p4": "음소거, 강퇴, 참가 승인 등 완전한 그룹 관리",
  "showcase.security.title": "종단간 암호화",
  "showcase.security.tag": "프라이버시",
  "showcase.security.desc": "E2E 암호화 — 개인 키는 기기를 벗어나지 않음",
  "showcase.security.p1": "모든 메시지가 완전히 E2E 암호화 — 서버가 읽을 수 없음",
  "showcase.security.p2": "읽은 후 자동 삭제 지원",
  "showcase.security.p3": "셀프 호스트 — 데이터가 자체 서버에 저장",
  "showcase.security.p4": "정기적인 서드파티 보안 감사",

  // Pricing
  "pricing.label": "요금제",
  "pricing.title": "나에게 맞는 플랜 선택",
  "pricing.subtitle": "개인 개발자, 성장하는 팀, 대기업 — TupIM은 모든 규모에 맞는 플랜을 제공합니다.",
  "pricing.popular": "가장 인기",
  "pricing.includes": "포함된 기능",
  "pricing.note": "모든 플랜에 7일 무료 체험 포함. 신용카드 불필요.",
  "pricing.starter.name": "스타터",
  "pricing.starter.tag": "개인 / 소규모 팀",
  "pricing.starter.desc": "개인 개발자와 소규모 앱이 TupIM의 핵심 기능을 탐색하기에 적합.",
  "pricing.starter.cta": "무료로 시작",
  "pricing.starter.f1": "최대 500명 활성 사용자",
  "pricing.starter.f2": "텍스트, 이미지, 음성 메시지",
  "pricing.starter.f3": "일대일 음성 및 영상 통화",
  "pricing.starter.f4": "기본 그룹 (최대 50명)",
  "pricing.starter.f5": "커뮤니티 기술 지원",
  "pricing.starter.m1": "다자간 그룹 통화",
  "pricing.starter.m2": "프라이빗 배포",
  "pricing.starter.m3": "전담 기술 지원",
  "pricing.pro.name": "프로",
  "pricing.pro.tag": "성장 팀",
  "pricing.pro.desc": "빠르게 성장하는 제품과 팀을 위해. 전체 기능으로 수백만 사용자를 쉽게 처리.",
  "pricing.pro.cta": "영업팀 문의",
  "pricing.pro.f1": "최대 10,000명 활성 사용자",
  "pricing.pro.f2": "모든 리치 미디어 메시지",
  "pricing.pro.f3": "다자간 그룹 음성 및 영상 통화",
  "pricing.pro.f4": "최대 1,000명 그룹",
  "pricing.pro.f5": "화면 공유 및 통화 녹음",
  "pricing.pro.f6": "E2E 암호화 및 읽기 후 삭제",
  "pricing.pro.m1": "프라이빗 배포",
  "pricing.enterprise.name": "엔터프라이즈",
  "pricing.enterprise.tag": "대기업",
  "pricing.enterprise.desc": "대규모 애플리케이션 및 기업 요구를 위해 설계. 완전 셀프 호스트, 완전한 데이터 소유.",
  "pricing.enterprise.cta": "견적 받기",
  "pricing.enterprise.f1": "무제한 활성 사용자",
  "pricing.enterprise.f2": "모든 기능, 제한 없음",
  "pricing.enterprise.f3": "프라이빗 배포 및 소스 코드 라이선스",
  "pricing.enterprise.f4": "Kubernetes 클러스터 고가용성",
  "pricing.enterprise.f5": "SLA 99.99% 가동률 보장",
  "pricing.enterprise.f6": "전담 기술 컨설턴트",
  "pricing.enterprise.f7": "맞춤형 기능 개발",

  // Docs page
  "docs.title": "문서",
  "docs.group.start": "시작하기",
  "docs.group.core": "핵심 기능",
  "docs.group.dev": "개발자 가이드",
  "docs.nav.introduction": "소개",
  "docs.nav.quickstart": "빠른 시작",
  "docs.nav.messaging": "인스턴트 메시지",
  "docs.nav.calls": "음성 및 영상 통화",
  "docs.nav.groups": "그룹 관리",
  "docs.nav.encryption": "보안 및 암호화",
  "docs.nav.sdk": "SDK 통합",
  "docs.nav.deployment": "셀프 호스팅",
  "docs.nav.api": "API 레퍼런스",
  "docs.toc": "목차",
  "docs.copied": "복사됨",
  "docs.copy": "복사",
  "docs.install": "설치",
  "docs.init": "초기화",

  // Docs - Server group
  "docs.group.server": "서버",
  "docs.nav.sfu": "SFU 대역폭 계산",
  "docs.sfu.title": "SFU 서버 기반 화상 회의 대역폭 계산 방법",
  "docs.sfu.intro": "SFU 아키텍첫에서 각 참가자는 자신의 스트림을 SFU 서버에 업로드하고 서버는 다른 참가자의 스트림을 선택적으로 전달합니다. 이 문서에서는 SFU 기반 화상 회의의 대역폭 요구사항을 추정하는 방법을 설명합니다.",
  "docs.sfu.arch.title": "SFU 아키텍첫 개요",
  "docs.sfu.arch.desc": "MCU와 달리 SFU는 스트림을 혼합하지 않습니다. 각 참가자는 N-1개의 다운링크와 1개의 업링크를 유지합니다. 이로 인해 SFU는 대형 그룹 통화에 적합합니다.",
  "docs.sfu.formula.title": "대역폭 계산 공식",
  "docs.sfu.formula.uplink": "업링크(사용자당): 비디오 스트림 1개 업로드",
  "docs.sfu.formula.downlink": "다운링크(사용자당): (N-1)개 비디오 스트림 다운로드",
  "docs.sfu.formula.total": "서버 총 대역폭 = N × 업링크 비트레이트 + N × (N-1) × 다운링크 비트레이트",
  "docs.sfu.params.title": "참조 비트레이트 매개변수",
  "docs.sfu.params.hd": "HD(720p): 업 ~1.5 Mbps / 다운 ~1.2 Mbps",
  "docs.sfu.params.sd": "SD(480p): 업 ~0.8 Mbps / 다운 ~0.6 Mbps",
  "docs.sfu.params.ld": "저화질(240p): 업 ~0.3 Mbps / 다운 ~0.25 Mbps",
  "docs.sfu.example.title": "계산 예제",
  "docs.sfu.example.desc": "다음 예제는 HD 품질(720p)을 가정하며, 각 참가자의 업링크 1.5 Mbps, 다운링크 1.2 Mbps 입니다.",
  "docs.sfu.note.title": "중요 주의사항",
  "docs.sfu.note.1": "프로토콜 헤더, 재전송 및 RTCP 제어 트래픽에 약 20%의 오버헤드를 추가하세요.",
  "docs.sfu.note.2": "시뮬룽케스트를 활성화하면 SFU가 수신자별로 적응적으로 스트림 품질을 선택할 수 있습니다.",
  "docs.sfu.note.3": "오디오 스트림은 일반적으로 참가자당 50–100 kbps가 추가됩니다.",
  "docs.sfu.note.4": "화면 공유 스트림은 추가로 2–4 Mbps의 업링크 대역폭이 필요할 수 있습니다.",

  // Footer
  "footer.tagline": "TupIM\u00a0프라이버시 보호, 개인 채팅, 그룹 채팅, 보안 메시지 등",
  "footer.col.product": "제품",
  "footer.col.developer": "개발자",
  "footer.col.company": "회사",
  "footer.link.features": "기능",
  "footer.link.download": "다운로드",
  "footer.link.changelog": "변경 로그",
  "footer.link.docs": "문서",
  "footer.link.api": "API 레퍼런스",
  "footer.link.github": "GitHub",
  "footer.link.about": "회사 소개",
  "footer.link.blog": "블로그",
  "footer.link.contact": "문의",
  "footer.copyright": "© 2024 TupIM. All rights reserved.",
  "footer.lang.zh": "繁體中文",
  "footer.lang.en": "English",

  // About page
  "about.badge": "회사 소개",
  "about.hero.title": "차세대 오픈 소스 메시징 인프라 구축",
  "about.hero.desc": "TupIM은 수년간의 깊은 IM 전문 지식을 가진 엔지니어들이 설립하여 모든 개발자가 최소 비용으로 기업급 인스턴트 메시징을 구축할 수 있도록 하는 데 전념합니다.",
  "about.hero.cta1": "문의하기",
  "about.hero.cta2": "GitHub 보기",
  "about.stat.devs": "글로벌 개발자",
  "about.stat.msgs": "메시지 / 일",
  "about.stat.stars": "GitHub Stars",
  "about.stat.countries": "국가",
  "about.mission.label": "미션 & 비전",
  "about.mission.title": "모든 앱에 강력한 메시징이 필요합니다",
  "about.mission.p1": "IM 기술은 오랫동안 대형 플레이어들이 독점해왔습니다. TupIM은 이 사이클을 깨기 위해 만들어졌습니다.",
  "about.mission.p2": "우리는 완전한 오픈 소스 IM 솔루션을 제공합니다 — 서버, Web SDK, iOS SDK 및 Android SDK.",
  "about.mission.p3": "우리의 비전: 전 세계에서 가장 신뢰받는 오픈 소스 메시징 인프라가 되는 것.",
  "about.values.label": "핵심 가치",
  "about.values.title": "우리가 믿는 것",
  "about.values.subtitle": "이 가치들이 우리의 모든 기술적 결정과 제품 방향을 이끕니다.",
  "about.value.opensource.title": "개방 & 투명성",
  "about.value.opensource.desc": "모든 코드가 MIT 라이선스 하에 GitHub에 완전히 공개되어 있습니다.",
  "about.value.privacy.title": "프라이버시 우선",
  "about.value.privacy.desc": "종단간 암호화는 선택이 아닌 표준입니다. 프라이빗 배포로 데이터가 제3자에게 절대 전달되지 않습니다.",
  "about.value.performance.title": "극한 성능",
  "about.value.performance.desc": "Go 기반의 고성능 서버로 단일 노드에서 수백만 동시 연결 처리.",
  "about.value.community.title": "커뮤니티 중심",
  "about.value.community.desc": "제품 방향은 커뮤니티에 의해 결정됩니다.",
  "about.value.developer.title": "개발자 경험",
  "about.value.developer.desc": "풍부한 문서, 포괄적인 데모, 깔끔한 SDK API로 통합을 최대한 쉽게.",
  "about.value.enterprise.title": "엔터프라이즈 준비",
  "about.value.enterprise.desc": "Kubernetes 클러스터, 멀티 리전 HA, 완전한 모니터링으로 프로덕션 환경에 완벽.",
  "about.timeline.label": "마일스톤",
  "about.timeline.title": "우리가 걸어온 모든 걸음",
  "about.timeline.2020q1.date": "2020 Q1",
  "about.timeline.2020q1.title": "프로젝트 시작",
  "about.timeline.2020q1.desc": "핵심 팀 구성, Go 기반 고성능 IM 서버 아키텍처 연구 및 설계 시작.",
  "about.timeline.2020q3.date": "2020 Q3",
  "about.timeline.2020q3.title": "첫 오픈 소스 출시",
  "about.timeline.2020q3.desc": "GitHub에 OpenIM Server v1.0 게시, 첫 주에 500+ 스타 획득.",
  "about.timeline.2021q2.date": "2021 Q2",
  "about.timeline.2021q2.title": "전체 플랫폼 SDK 커버리지",
  "about.timeline.2021q2.desc": "iOS, Android 및 Web SDK 동시 출시.",
  "about.timeline.2022q1.date": "2022 Q1",
  "about.timeline.2022q1.title": "GitHub 10,000 Stars",
  "about.timeline.2022q1.desc": "GitHub 스타 10K 돌파, Go 생태계에서 가장 인기 있는 오픈 소스 IM 프로젝트 중 하나가 됨.",
  "about.timeline.2022q4.date": "2022 Q4",
  "about.timeline.2022q4.title": "엔터프라이즈 에디션 출시",
  "about.timeline.2022q4.desc": "프라이빗 배포, 전담 지원 및 SLA 보장이 포함된 엔터프라이즈 플랜 출시.",
  "about.timeline.2023q2.date": "2023 Q2",
  "about.timeline.2023q2.title": "음성 & 비디오 모듈 라이브",
  "about.timeline.2023q2.desc": "WebRTC 기반 HD 통화 모듈 공식 통합.",
  "about.timeline.2024q1.date": "2024 Q1",
  "about.timeline.2024q1.title": "글로벌 개발자 50,000명",
  "about.timeline.2024q1.desc": "전 세계 80개국 이상 50K+ 개발자 사용, 일일 메시지 2억 건 초과.",
  "about.timeline.2024q4.date": "2024 Q4",
  "about.timeline.2024q4.title": "TupIM 브랜드 업그레이드",
  "about.timeline.2024q4.desc": "TupIM으로 전체 브랜드 업그레이드, 새 웹사이트 및 문서 시스템 출시.",
  "about.team.label": "우리 팀",
  "about.team.title": "TupIM을 만드는 사람들",
  "about.team.subtitle": "오픈 소스를 사랑하고 IM 기술에 열정을 가진 엔지니어 그룹.",
  "about.team.ceo.name": "Alex Chen",
  "about.team.ceo.role": "CEO & Co-Founder",
  "about.team.ceo.bio": "대형 기술 회사의 전직 IM 아키텍트, 10년 이상의 경험을 보유.",
  "about.team.cto.name": "Kevin Wang",
  "about.team.cto.role": "CTO & Co-Founder",
  "about.team.cto.bio": "Go 핵심 기여자이자 OpenIM Server의 수석 아키텍트.",
  "about.team.lead.name": "Sophie Lin",
  "about.team.lead.role": "Lead Engineer",
  "about.team.lead.bio": "Web SDK 및 프론트엔드 아키텍처를 담당하는 풀스택 엔지니어.",
  "about.team.sdk.name": "James Zhang",
  "about.team.sdk.role": "Mobile SDK Lead",
  "about.team.sdk.bio": "iOS & Android 이중 전문가, 모바일 SDK 설계를 이끌고 있습니다.",
  "about.team.infra.name": "David Liu",
  "about.team.infra.role": "Infrastructure Lead",
  "about.team.infra.bio": "Kubernetes 전문가, TupIM의 클라우드 네이티브 배포 솔루션을 담당.",
  "about.team.design.name": "Emma Wu",
  "about.team.design.role": "Product Design Lead",
  "about.team.design.bio": "개발자 도구에 집중한 UX 전문가.",

  // Contact page
  "contact.badge": "문의하기",
  "contact.hero.title": "질문이 있으신가요? 저희가 여기 있습니다.",
  "contact.hero.desc": "기술 문제, 비즈니스 문의, 미디어 요청 등 — 가장 적합한 채널을 선택하여 문의해 주세요.",
  "contact.channel.support.title": "기술 지원",
  "contact.channel.support.desc": "버그, SDK 문제 또는 배포 질문이 있으신가요? GitHub 이슈를 열거나 Slack 커뮤니티에 참여하세요.",
  "contact.channel.support.link1": "GitHub 이슈 제출",
  "contact.channel.support.link2": "Slack 커뮤니티 참여",
  "contact.channel.business.title": "비즈니스 문의",
  "contact.channel.business.desc": "엔터프라이즈 플랜, 상업 라이선스 또는 맞춤형 개발 파트너십에 관심이 있으신가요?",
  "contact.channel.business.link1": "비즈니스 이메일 발송",
  "contact.channel.business.link2": "WeChat 상담",
  "contact.channel.media.title": "미디어 & PR",
  "contact.channel.media.desc": "언론 인터뷰, 제품 리뷰 또는 협업 이벤트? 저희 PR 팀에 연락해 주세요.",
  "contact.channel.media.link1": "미디어 연락 이메일",
  "contact.channel.media.link2": "Twitter 팔로우",
  "contact.channel.community.title": "오픈 소스 커뮤니티",
  "contact.channel.community.desc": "오픈 소스 커뮤니티에 참여하여 전 세계 개발자들과 교류하세요.",
  "contact.channel.community.link1": "Slack 참여",
  "contact.channel.community.link2": "GitHub 팔로우",
  "contact.response.note": "일반적인 응답 시간: 기술 문제 24시간 이내 · 비즈니스 문의 1-2 영업일 · 미디어 요청 2-3 영업일",
  "contact.faq.label": "FAQ",
  "contact.faq.title": "자주 묻는 질문",
  "contact.faq.f1.q": "TupIM은 완전히 무료인가요?",
  "contact.faq.f1.a": "예 — TupIM 서버와 모든 클라이언트 SDK는 MIT 라이선스 하에 완전히 오픈 소스 및 무료입니다.",
  "contact.faq.f2.q": "TupIM을 빠르게 시작하려면 어떻게 해야 하나요?",
  "contact.faq.f2.a": "빠른 시작 문서를 확인하세요. Docker Compose로 5분 안에 서버를 배포할 수 있습니다.",
  "contact.faq.f3.q": "데이터 보안과 프라이버시는 어떻게 보장되나요?",
  "contact.faq.f3.a": "TupIM은 프라이빗 배포를 지원합니다 — 모든 데이터가 귀하의 서버에 있으며 저희는 귀하의 데이터에 접근할 수 없습니다.",
  "contact.faq.f4.q": "어떤 규모의 동시성을 지원하나요?",
  "contact.faq.f4.a": "TupIM Server의 Go 기반 아키텍처는 단일 노드에서 100만 이상의 동시 연결을 처리합니다.",
  "contact.faq.f5.q": "엔터프라이즈 라이선스는 어떻게 받나요?",
  "contact.faq.f5.a": "비즈니스 이메일이나 WeChat을 통해 영업팀에 연락하여 귀하의 비즈니스 규모와 요구 사항을 설명해 주세요.",

  "nav.about": "회사 소개",
  "nav.contact": "문의",

  // Page title
  "page.title": "TupIM — 프라이버시 보호, 개인 채팅 | 그룹 채팅 | 보안 메시지 & 개 이상",
};

export default common;